<template>
 <AppDialog :is-open="isOpen"
            :ok-title="$t('common.delete')"
            :ok-loading="deleteQuestionPending"
            :ok-disabled="deleteQuestionPending"
            :cancel-disabled="deleteQuestionPending"
            @ok="prepareDeleteQuestion"
            @cancel="closeDialog"
 >
   <template #title>
     {{ $t('project.question-answer.QuestionAnswerQuestionDeleteDialog.title') }}
   </template>
   <template #body>
     <div>
       {{ $t('project.question-answer.QuestionAnswerQuestionDeleteDialog.text') }}
     </div>
   </template>
 </AppDialog>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { toast } from '@/common/utils/toast'
import { QuestionAnswerActionTypes } from '@/store/modules/question-answer/action_types'
import { QuestionAnswerMutationTypes } from '@/store/modules/question-answer/mutation_types'

export default {
  name: 'QuestionAnswerQuestionDeleteDialog',
  components: { AppDialog },
  props: {
    questionId: {
      required: true,
      validator: (value) => {
        return value === null || typeof value === 'number'
      },
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters('room', ['roomMnemo']),
    ...mapState('questionAnswer', ['deleteQuestionPending', 'questions']),
  },
  methods: {
    ...mapActions('questionAnswer', [QuestionAnswerActionTypes.DELETE_QUESTION]),
    ...mapMutations('questionAnswer', [QuestionAnswerMutationTypes.REMOVE_QUESTION_FROM_LIST]),
    async prepareDeleteQuestion () {
      try {
        await this.DELETE_QUESTION({
          mnemo: this.roomMnemo,
          questionId: this.questionId,
        })
        toast.success(this.$t('project.question-answer.QuestionAnswerQuestionDeleteDialog.deleteQuestionSuccess'))
        this.closeDialog()
        this.REMOVE_QUESTION_FROM_LIST(this.questionId)
      } catch (error) {
        toast.error(this.$t('project.question-answer.QuestionAnswerQuestionDeleteDialog.deleteQuestionError'))
      }
    },
    closeDialog () {
      this.$emit('onClose')
    },
  },
}
</script>
